export const FILTER_SET = 'FILTER_SET';
export const FILTER_CLEAR = 'FILTER_CLEAR';
export const FILTER_MIDDLEWARE_SET = 'FILTER_MIDDLEWARE_SET';

export const setFilter = (name, value) => ({
  type: FILTER_SET,
  payload: {
    name,
    value,
  },
});

export const clearFilter = name => ({
  type: FILTER_CLEAR,
  payload: {
    name,
  },
});

export const setFilterMiddleware = (name, middleware, value) => ({
  type: FILTER_MIDDLEWARE_SET,
  payload: {
    name,
    middleware,
    value,
  },
});



// WEBPACK FOOTER //
// ./src/store/filter/actions.js